import { gql } from '@apollo/client';

export const CHECKLIST_QUESTIONS_PAGE_QUERY = gql`
  query checklistQuestions(
    $limit: Int!
    $offset: Int!
    $q: String
    $withDeleted: Boolean
    $orderBy: String
    $orderDirection: String
    $columnFilters: [ColumnFilter!]
  ) {
    checklistQuestions(
      limit: $limit
      offset: $offset
      q: $q
      withDeleted: $withDeleted
      orderBy: $orderBy
      orderDirection: $orderDirection
      columnFilters: $columnFilters
    ) {
      id
      hasDraft
      currentVersion {
        id
        createdById
        status
        updatedById
        version
        text
        guidance
        description
        negativeResultSeverityId
        negativeResultAlert
        deletedAt
        checklistQuestionIdAlias
        isWildCardQuestion
        skipImportForDesktop
        skipImportForWeb

      }
    }
    checklistQuestionsPageInfo(
      q: $q
      columnFilters: $columnFilters
      withDeleted: $withDeleted
    ) {
      totalCount
    }
  }
`;

export const CHECKLIST_QUESTIONS_QUERY = gql`
  query checklistQuestions($limit: Int!, $offset: Int!, $q: String, $withDeleted: Boolean) {
    checklistQuestions(limit: $limit, offset: $offset, q: $q, withDeleted: $withDeleted) {
      id
      hasDraft
      currentVersion {
        deletedAt
        id
        createdById
        status
        updatedById
        version
        text
        guidance
        description
        negativeResultSeverityId
        negativeResultAlert
        checklistQuestionIdAlias
        isWildCardQuestion
        skipImportForDesktop
        skipImportForWeb
      }
    }
  }
`;

export const CHECKLIST_QUESTION_QUERY = gql`
  query checklistQuestion($id: Int!) {
    checklistQuestion(id: $id) {
      id
      currentVersion {
        id
        createdById
        status
        updatedById
        version
        text
        guidance
        description
        negativeResultSeverityId
        negativeResultAlert
        deletedAt
        checklistQuestionIdAlias
        nonCompliances {
          id
          description
        }
        clientSpecificConfigurations {
          id
          companyId
          text
          guidance
          description
          logicType,
          serviceIds
        }
        isWildCardQuestion
        skipImportForDesktop
        skipImportForWeb
      }
    }
  }
`;

export const CHECKLIST_QUESTION_VERSION_LAWS_QUERY = gql`
  query checklistQuestionVersion($id: Int!, $countryId: Int) {
    checklistQuestionVersion(id: $id, countryId: $countryId) {
      id
      nonCompliances {
        id
        laws {
          id
          currentVersion {
            id
            articleSecNo
            internalGuidelineInterpretation
            legalCitation
            legalReqSummary
            legislationName
          }
        }
      }
    }
  }
`;

export const CHECKLIST_QUESTION_VERSIONS_QUERY = gql`
  query checklistQuestionVersions(
    $limit: Int
    $offset: Int
    $checklistQuestionId: Int!
  ) {
    checklistQuestionVersions(
      limit: $limit
      offset: $offset
      checklistQuestionId: $checklistQuestionId
    ) {
      checklistQuestionId
      createdAt
      createdById
      id
      updatedAt
      updatedById
      version
      status
      text
      guidance
      description
      negativeResultSeverityId
      negativeResultAlert
      deletedAt
      checklistQuestionIdAlias
      nonCompliances {
        id
        description
      }
      clientSpecificConfigurations {
        id
        companyId
        text
        guidance
        description
        logicType
        serviceIds
      }
      isWildCardQuestion
      skipImportForDesktop
      skipImportForWeb
    }
  }
`;
